// FoodRatesTable.jsx
import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faSortUp,
  faSortDown
} from '@fortawesome/free-solid-svg-icons';

import { dictionary_default, ageCategoryLabel } from '../GroupDetail/data';

import './FoodRatesTable.css';

// Основной компонент таблицы харчування
const FoodRatesTable = ({
  data = [],
  columnsConfig = []
}) => {

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });


  
const getRow = (row,i) =>(
  { id: row._id , number: i+1,
    rateType: row.dateTo ? "тимчасовий" : "постійний", 
    rate: row.averageForDay + " грн.",
    startDate: new Date(row.dateFrom).toLocaleDateString('uk') , 
    ageCategory: ageCategoryLabel(row.ageLimit), 
    foodType: dictionary_default.typeKitchen[row.typeKitchen || "standart"],
    endDate:  row.dateTo ? new Date(row.dateTo).toLocaleDateString('uk') : ''
  }
)


  // Конфигурация столбцов по умолчанию
  const defaultColumns = [
    {
      key: 'rateType',
      label: 'Тип тарифу',
      sortable: true,
      width: '15%'
    },
    {
      key: 'foodType',
      label: 'Тип харчування',
      sortable: true,
      width: '20%'
    },
    {
      key: 'ageCategory',
      label: 'Вікова категорія',
      sortable: true,
      width: '15%'
    },
    {
      key: 'rate',
      label: 'Тариф',
      sortable: true,
      width: '15%'
    },
    {
      key: 'startDate',
      label: 'Дата початку дії',
      sortable: true,
      width: '15%'
    },
    {
      key: 'endDate',
      label: 'Дата завершення дії',
      sortable: true,
      width: '15%'
    }
  ];

  const columns = columnsConfig.length > 0 ? columnsConfig : defaultColumns;

  // Функция сортировки
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Сортированные данные
  const sortedData = useMemo(() => {

    const data_ = data.map(r=>getRow(r));
    if (!sortConfig.key) return data_;
    
    return [...data_].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [data, sortConfig]);

  const getSortIcon = (columnKey) => {
    if (columnKey !== sortConfig.key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  return (
    <div className="food-rates-table-container">
      <div className="table-responsive">
        <table className="table align-middle food-rates-table" style={{ fontSize: '14px' }}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th 
                  key={column.key} 
                  style={{ 
                    width: column.width,
                    cursor: column.sortable ? 'pointer' : 'default',
                    color: '#262e35ff',
                    fontWeight: 600,
                    borderBottom: '1px solid #6c757d',
                    padding: '10px 8px'
                  }}
                  onClick={() => column.sortable && handleSort(column.key)}
                >
                  <div className="d-flex align-items-center">
                    {column.label}
                    {column.sortable && (
                      <FontAwesomeIcon 
                        icon={getSortIcon(column.key)} 
                        className="ms-1" 
                        style={{ fontSize: '12px' }}
                      />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item, index) => (
              <tr key={index} className={index % 2 === 0 ? '' : 'bg-light'}>
                {columns.map((column) => (
                  <td key={column.key} style={{ padding: '10px 8px', borderBottom: '1px solid #e9ecef' }}>
                    {item[column.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {data.length === 0 && (
        <div className="text-center py-4 text-muted">
          Немає даних про тарифи харчування
        </div>
      )}
      
      <div className="table-footer-note">
        Всього тарифів: {data.length}
      </div>
    </div>
  );
};

export default FoodRatesTable;